module.exports = __webpack_public_path__ + "static/media/Plane.8a44b579.svg";